import React from 'react';
import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller';
import { FilterHeaderWrapper, RelativeWrapper, DropdownOuterWrapper, FlexCenterWrapper, Mx4, Pb4, Mr3, Pl4, StickyTopWrapper, Py2 } from 'wrappers';
import { Icon, SecondaryTextXs, BorderlessKeyInput, UnderlinedTabButton } from 'atoms';
import { DropdownTextButton, AssignWorkerDropdownButton } from 'molecules';
import internalState from './internalState';
import { DownCaretSvg } from 'components/icons';
import { AssignWorkerRow } from 'containers';
import { ContentWrapper } from './wrappers';
import { getAdminList, getTechList, getVendorList } from './utils';
import { textEllipsis } from 'utils/ellipsis';


export const definition = {
  name: 'AssignWorkerDropdown',
  controller: Controller,
  initialProps: ({ assignedTechId, assignedVendorId, label, techs, vendors, textHeader, admins, hideAdmins, hideTechs, hideVendors, assignedAdminId }) =>
  ({
    assignedTechId,
    assignedVendorId,
    label,
    admins,
    techs,
    vendors,
    textHeader,
    hideAdmins,
    hideTechs,
    hideVendors,
    assignedAdminId,
    containerRef: React.createRef(),
    selectedTab: !hideTechs ? 'techs' : !hideVendors ? 'vendors' : !hideAdmins ? 'admins' : ''
  }),
  props: internalState,
  elements: [
    {
      wrapper: RelativeWrapper,
      name: 'Wrapper',
      ref: ({ containerRef }) => containerRef,
      elements: [
        {
          component: AssignWorkerDropdownButton,
          name: "HeaderWrapper",
          renderIf: ({ textHeader, isOpen }) => textHeader && !isOpen,
          bindings: ({ isOpen, techs, vendors, assignedTechId, assignedVendorId, containerRef, admins, assignedAdminId }) => {
            let title = 'Assign';

            if (assignedTechId) {
              let tech = techs.find(t => t.id === assignedTechId);
              if (tech) {
                title = `Assigned to ${tech.name}`
              }
            }
            if (assignedVendorId) {
              let vendor = vendors.find(v => v.id === assignedVendorId);
              if (vendor) {
                title = `Assigned to ${vendor.name}`
              }
            }
            if (assignedAdminId) {
              let admin = admins.find(a => a.id === assignedAdminId);
              if (admin) {
                title = `Assigned to ${admin.name}`
              }
            }

            return { title, isOpen, containerRef }
          },
        },
        {
          wrapper: FilterHeaderWrapper,
          name: 'HeaderWrapper',
          isButton: true,
          bindings: ({ isOpen, containerRef }) => ({ isOpen, containerRef }),
          renderIf: ({ textHeader, isOpen }) => !textHeader || isOpen,
          elements: [
            {
              wrapper: FlexCenterWrapper,
              name: 'LeftSide',
              elements: [
                {
                  component: SecondaryTextXs,
                  name: 'Label',
                  renderIf: ({ label }) => !!label,
                  displayValue: ({ label }) => label
                },
                {
                  component: DropdownTextButton,
                  name: 'SelectedTechButton',
                  renderIf: ({ assignedTechId, techs }) => !!assignedTechId && techs.find(tech => tech.id === assignedTechId),
                  bindings: ({ techs, assignedTechId }) => ({ text: textEllipsis(techs.find(tech => tech.id === assignedTechId).name, 25) })
                },
                {
                  component: DropdownTextButton,
                  name: 'SelectedVendorButton',
                  renderIf: ({ assignedVendorId, vendors }) => !!assignedVendorId && vendors.find(vendor => vendor.id === assignedVendorId),
                  bindings: ({ vendors, assignedVendorId }) => ({ text: textEllipsis(vendors.find(vendor => vendor.id === assignedVendorId).name, 25) })
                },
                {
                  component: DropdownTextButton,
                  name: 'SelectedAdminButton',
                  renderIf: ({ assignedAdminId, admins }) => !!assignedAdminId && admins.find(a => a.id === assignedAdminId),
                  bindings: ({ assignedAdminId, admins }) => ({ text: textEllipsis(admins.find(a => a.id === assignedAdminId).name, 25) })
                },
                {
                  component: BorderlessKeyInput,
                  name: 'Search',
                  renderIf: ({ assignedTechId, assignedVendorId, assignedAdminId }) => !assignedTechId && !assignedVendorId && !assignedAdminId,
                  bindings: ({ searchVal }) => ({ value: searchVal, placeholder: 'Search...' })
                },
              ]
            },
            {
              component: Icon,
              name: 'CaretIcon',
              displayValue: ({ }) => DownCaretSvg({})
            }
          ]
        },
        {
          wrapper: DropdownOuterWrapper,
          name: "ContentWrapper",
          renderIf: ({ isOpen }) => isOpen,
          elements: [
            {
              wrapper: ContentWrapper,
              name: 'Content',
              elements: [
                {
                  wrapper: wrap(wrap(wrap(FlexCenterWrapper, Py2), Pl4), StickyTopWrapper),
                  name: 'Tabs',
                  elements: [
                    {
                      component: wrap(UnderlinedTabButton, Mr3),
                      name: 'Techs',
                      displayValue: ({ }) => 'Techs',
                      renderIf: ({ hideTechs }) => !hideTechs,
                      displayState: ({ selectedTab }) => ({ selected: selectedTab === 'techs' }),
                      bindings: ({ }) => ({})
                    },
                    {
                      component: wrap(UnderlinedTabButton, Mr3),
                      name: 'Vendors',
                      displayValue: ({ }) => 'Vendors',
                      renderIf: ({ hideVendors }) => !hideVendors,
                      displayState: ({ selectedTab }) => ({ selected: selectedTab === 'vendors' }),
                      bindings: ({ }) => ({})
                    },
                    {
                      component: UnderlinedTabButton,
                      name: 'Admins',
                      displayValue: ({ }) => 'Admins',
                      renderIf: ({ hideAdmins }) => !hideAdmins,
                      displayState: ({ selectedTab }) => ({ selected: selectedTab === 'admins' }),
                      bindings: ({ }) => ({})
                    },
                  ]
                },
                {
                  component: wrap(SecondaryTextXs, Mx4),
                  name: 'NoTechAvailable',
                  renderIf: ({ searchVal, techs, selectedTab }) => getTechList({ searchVal, techs }).length === 0 && selectedTab === 'techs',
                  displayValue: ({ }) => 'No technician available'
                },
                {
                  component: AssignWorkerRow,
                  name: 'AssignTech',
                  renderIf: ({ selectedTab }) => selectedTab === 'techs',
                  isListOf: { tech: getTechList },
                  bindings: ({ tech, assignedTechId }) => ({ image: tech.image, name: tech.name, assignments: tech.stats.assigned, completion_time: tech.stats.completion_time, rating: tech.stats.rating, id: tech.id, assignedId: assignedTechId })
                },
                {
                  component: wrap(wrap(SecondaryTextXs, Mx4), Pb4),
                  name: 'NoVendorsAvailable',
                  renderIf: ({ selectedTab, searchVal, vendors }) => getVendorList({ searchVal, vendors }).length === 0 && selectedTab === 'vendors',
                  displayValue: ({ }) => 'No vendor available'
                },
                {
                  component: AssignWorkerRow,
                  name: 'AssignVendor',
                  renderIf: ({ selectedTab }) => selectedTab === 'vendors',
                  isListOf: { vendor: getVendorList },
                  bindings: ({ vendor, assignedVendorId }) => ({ image: vendor?.vendor_url ?? vendor?.attachment, name: vendor.name, assignments: vendor.stats?.assigned, completion_time: vendor.stats?.completion_time, rating: vendor.stats?.rating, id: vendor.id, assignedId: assignedVendorId })
                },
                {
                  component: wrap(wrap(SecondaryTextXs, Mx4), Pb4),
                  name: 'NoAdminsAvailable',
                  renderIf: ({ selectedTab, searchVal, admins }) => getAdminList({ searchVal, admins })?.length === 0 && selectedTab === 'admins',
                  displayValue: ({ }) => 'No admin available'
                },
                {
                  component: AssignWorkerRow,
                  name: 'AssignAdmin',
                  renderIf: ({ selectedTab }) => selectedTab === 'admins',
                  isListOf: { admin: getAdminList },
                  bindings: ({ admin }) => ({
                    image: admin.image,
                    name: admin.name,
                    assignments: 0,
                    completion_time: 0,
                    rating: 0,
                    id: admin.id,
                    role: admin.is_super_admin ? 'Super Admin' : admin.roles.length > 0 ? admin.roles.map(r => r.name).join(', ') : 'No role',
                    displayButton: true
                  })
                },
              ]
            }
          ]
        }

      ]
    }
  ]
}
export default ContainerComponent(definition)